function productVariants(){
  var $productSelect = $("#product-select");

  $(".radio-holder input, .main-add-form .select-wrapper select").not('.disable-select').on("change", function() {
    var option_target = "";
    var $self = $(this);

    $(".radio-holder input:checked, .main-add-form .select-wrapper select option:selected").not('.disable-select option:selected').each(function() {
      var $this = $(this);
      var dataIndex = $this.data("index");
      var eleValue = $this.val();
      option_target += `[data-option-${dataIndex}="${eleValue}"]`;
    });

    var $option = $productSelect.find(option_target);
    var price = $option.data('price');
    var comparePrice = $option.data('compare-price')
    var backOrder = $option.data('backorder')
    var selectedVal = $option.val();

    if (backOrder) {
      $('form[action="/cart/add"] input[type="submit"]').each(function() {
        const $submit = $(this);
        //$submit.prop('disabled', true);
        //$submit.val($submit.data('sold'));
        if($('#BIS_trigger').length > 0) {
          $('#BIS_trigger').data('variant-id', selectedVal)
        } else {
          var obj_str = '<a href="#" id="BIS_trigger" data-variant-id="' + selectedVal + '" class="btn btn-backinstock">Notify me when available</a>';

          if (typeof __backorder_estimated_ship_date != "undefined") {
            obj_str += '<p class="estimated_shipdate">Estimated ship date: ' + __backorder_estimated_ship_date + '</p>';
          }
          $submit.after(obj_str);
        }
        $('#BIS_trigger').show();
        $('p.estimated_shipdate').show();
        $('label.qty-label').hide();
        $('div.qty-wrapper').hide();
        $submit.hide()
      })
    } else if ($option.prop('disabled')) {
      $('form[action="/cart/add"] input[type="submit"]').each(function() {
        const $submit = $(this);
        $('#BIS_trigger').hide();
        $('p.estimated_shipdate').hide();
        $('label.qty-label').hide();
        $('div.qty-wrapper').hide();
        $submit.show();
        $submit.prop('disabled', true);
        $submit.val($submit.data('sold'));
      })
    }else{
      $('form[action="/cart/add"] input[type="submit"]').each(function() {
        const $submit = $(this);
        $('#BIS_trigger').hide();
        $('p.estimated_shipdate').hide();
        $('label.qty-label').show();
        $('div.qty-wrapper').show();
        $submit.show();
        $submit.prop('disabled', false);
        $submit.val($submit.data('submit'));
      })
    }

    $productSelect.val(selectedVal).trigger('change');
    $self.parents('.product__details').find('.price .regular-price').text(price);
    $self.parents('.product__details').find('.price .compare-price del').text(comparePrice);
    history.pushState(null, null, window.location.origin + window.location.pathname + '?variant=' + selectedVal, '');
  });

}

export default productVariants();



// WEBPACK FOOTER //
// ../markup/assets/js/product-variants.js